<div class="row" style="padding-top: 100px;">
  <div class="col-sm-1"></div>
  <div class="col-sm-10"></div>
  <div class="col-sm-1"></div>
</div>
<div
  class="container"
  style="padding-right: 50px; padding-left: 50px; max-width: 93.5%;"
>
  <div class="row" style="margin-left: -62px; margin-top: 54px;">
    <p class="title-hubungi">
      Hubungi Kami
    </p>
  </div>
  <div
    style="
      margin-top: -19px;
      margin-left: -49px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #737b7d;
      margin-bottom: 20px;
    "
  >
    Sampaikan pertanyaan maupun
    <a
      href="https://sukandaonline.typeform.com/to/fLCeKsPL"
      style="color: #737b7d; text-decoration: none;"
      >feedback</a
    >
    Anda
  </div>
  <div class="row">
    <div class="col-md-12 hidden-xs hidden-sm" style="float: left !important;">
      <div class="yCmsContentSlot login-right-content-slot">
        <div class="yCmsComponent login-right-content-component">
          <div class="hubungi-kami-gmaps">
            <!-- <agm-map [latitude]="lat" [longitude]="lng"  [zoom]="zoom">
              <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
            </agm-map> -->

            <a
              href="https://www.google.com/maps/place/PT+SUKANDA+DJAYA/@-6.3156837,107.0947551,21z/data=!4m5!3m4!1s0x2e6991abd2ec5811:0x41670901253ed9d5!8m2!3d-6.3157467!4d107.0948932"
            >
              <img class="img-sukanda img-fluid" src="assets/img/gmaps_sukanda.PNG" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-1">
      <img
        src="assets/img/Call.png"
        style="
          position: static;
          width: 28px;
          height: 28px;
          left: 0px;
          top: 0px;

          /* Inside Auto Layout */
          flex: none;
          order: 0;
          flex-grow: 0;
          margin-top: 48px;
          margin-left: -37px;
        "
      />
      <br />
      <img
        src="assets/img/wacontact.png"
        style="
          position: static;
          width: 28px;
          height: 28px;
          left: 0px;
          top: 0px;

          /* Inside Auto Layout */
          flex: none;
          order: 0;
          flex-grow: 0;
          margin-top: 26px;
          margin-left: -37px;
        "
      />
      <br />
      <img
        src="assets/img/Link.png"
        style="
          position: static;
          width: 28px;
          height: 28px;
          left: 0px;
          top: 0px;

          /* Inside Auto Layout */
          flex: none;
          order: 0;
          flex-grow: 0;
          margin-top: 26px;
          margin-left: -37px;
        "
      />
      <br />
      <img
        src="assets/img/At-sign.png"
        style="
          position: static;
          width: 28px;
          height: 28px;
          left: 0px;
          top: 0px;

          /* Inside Auto Layout */
          flex: none;
          order: 0;
          flex-grow: 0;
          margin-top: 26px;
          margin-left: -37px;
        "
      />
      <br />
      <img
        src="assets/img/Location.png"
        style="
          position: static;
          width: 28px;
          height: 28px;
          left: 0px;
          top: 0px;

          /* Inside Auto Layout */
          flex: none;
          order: 0;
          flex-grow: 0;
          margin-top: 26px;
          margin-left: -37px;
        "
      />
    </div>

    <div class="col-md-1">
      <p class="no-telp">
        1500982
      </p>
      <p class="wa-us">
        081285015025 (Text Only)
      </p>
      <p class="web-us">
        https://sukandadjaya.com
      </p>
      <p class="email-us">
        customer.support@sukandaonelink.com
      </p>
      <p class="wa-us">
        MM 2100 INDUSTRIAL TOWN JL.Irian Blok FF-2 Cibitung, Bekasi 17520 Jawa
        Barat, Indonesia
      </p>
    </div>

    <div
      class="col-md-1"
      style="
        border-right: 1px solid #e8e8e8;
        margin-top: 24px;
        margin-left: auto;
      "
    ></div>
    <div class="col-md-8" style="margin-top: 24px;">
      <form
        [formGroup]="complaintForm"
        (ngSubmit)="submitForm()"
        class="form-keluhan"
      >
        <div class="row">
          <div class="col-sm-6">
            <div
              class="form-group"
              style="margin: bottom 10px; position: relative;"
            >
              <div
                class="form-input-container"
                style="
                  position: relative;
                  margin-bottom: -8px;
                  left: 0px;
                  right: 0px;
                  top: 0px;
                  bottom: 0px;

                  background: #fafbfd;
                  border-radius: 4px;
                "
              >
                <input
                  id="name"
                  name="name"
                  formControlName="name"
                  class="form-control"
                  placeholder="Nama"
                  type="text"
                  style="
                    left: 20px;
                    right: 16px;
                    top: 11px;
                    bottom: 11px;

                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 20px;

                    /* identical to box height, or 143% */
                    display: flex;
                    align-items: center;
                    letter-spacing: 0.2px;
                    background-color: #fafbfd;
                    color: #a0a3bd;
                  "
                />
                <div *ngIf="submitted && f.name?.invalid" class="invalid">
                  <div *ngIf="f.name?.errors.required">
                    &#65121; Nama harus diisi.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div
              class="form-group"
              style="margin: bottom 10px; position: relative;"
            >
              <div
                class="form-input-container"
                style="
                  position: relative;
                  margin-bottom: -8px;
                  left: 0px;
                  right: 0px;
                  top: 0px;
                  bottom: 0px;

                  background: #fafbfd;
                  border-radius: 4px;
                "
              >
                <input
                  id="email"
                  name="email"
                  formControlName="email"
                  class="form-control"
                  placeholder="Email"
                  type="text"
                  style="
                    left: 20px;
                    right: 16px;
                    top: 11px;
                    bottom: 11px;

                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 20px;

                    /* identical to box height, or 143% */
                    display: flex;
                    align-items: center;
                    letter-spacing: 0.2px;
                    background-color: #fafbfd;
                    color: #a0a3bd;
                  "
                />
                <div *ngIf="submitted && f.email?.invalid" class="invalid">
                  <div *ngIf="f.email?.errors.required">
                    &#65121; Email harus diisi.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div
              class="form-group"
              style="margin: bottom 10px; position: relative;"
            >
              <div
                class="form-input-container"
                style="
                  position: relative;
                  margin-bottom: -8px;
                  left: 0px;
                  right: 0px;
                  top: 0px;
                  bottom: 0px;

                  background: #fafbfd;
                  border-radius: 4px;
                "
              >
                <input
                  id="phone"
                  name="phone"
                  formControlName="phone"
                  class="form-control"
                  placeholder="Nomor Telepon"
                  type="text"
                  style="
                    left: 20px;
                    right: 16px;
                    top: 11px;
                    bottom: 11px;

                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 20px;

                    /* identical to box height, or 143% */
                    display: flex;
                    align-items: center;
                    letter-spacing: 0.2px;
                    background-color: #fafbfd;
                    color: #a0a3bd;
                  "
                />
                <div *ngIf="submitted && f.phone?.invalid" class="invalid">
                  <div *ngIf="f.phone?.errors.required">
                    &#65121; Nomor Telepon harus diisi.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div
              class="form-group"
              style="margin: bottom 10px; position: relative;"
            >
              <div
                class="form-input-container"
                style="
                  position: relative;
                  margin-bottom: -8px;
                  left: 0px;
                  right: 0px;
                  top: 0px;
                  bottom: 0px;

                  background: #fafbfd;
                  border-radius: 4px;
                "
              >
                <select
                  formControlName="category"
                  style="
                    left: 16px;
                    right: 16px;
                    top: 11px;
                    bottom: 11px;

                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 20px;

                    /* identical to box height, or 143% */
                    display: flex;
                    align-items: center;
                    letter-spacing: 0.2px;
                    background-color: #fafbfd;
                    color: #a0a3bd;
                    width: 100%;
                    height: 35px;
                    border: 1px solid #ced4da;
                    background-clip: padding-box;
                    border-radius: 0.25rem;
                  "
                  name="category"
                  id="category"
                  (change)="changeCat($event)"
                >
                  <option value="" disabled selected hidden
                    >&nbsp;&nbsp;Kategori</option
                  >
                  <option *ngFor="let b of Category" [value]="b">
                    &nbsp;&nbsp;{{b}}
                  </option>
                </select>
                <div *ngIf="submitted && f.category?.invalid" class="invalid">
                  <div *ngIf="f.category?.errors.required">
                    &#65121; Kategori harus diisi.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div
              class="form-group"
              style="margin: bottom 10px; position: relative;"
            >
              <div
                class="form-input-container"
                style="
                  position: relative;
                  margin-bottom: 24px;
                  left: 0px;
                  right: 0px;
                  top: 0px;
                  bottom: 0px;

                  background: #fafbfd;
                  border-radius: 4px;
                "
              >
                <textarea
                  #msg
                  class="form-control height-fix"
                  rows="5"
                  id="comment"
                  placeholder="Tulis Pesan"
                  name="complaint"
                  formControlName="complaint"
                  style="background-color: #fafbfd; font-size: 14px;"
                  required
                ></textarea>

                <div *ngIf="submitted && f.complaint?.invalid" class="invalid">
                  <div *ngIf="f.complaint?.errors.required">
                    &#65121; Tuliskan Pesan Anda
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="buttonSubmit">
          <button
            type="submit"
            class="btn complaint btn-block"
            [disabled]="complaintForm.invalid"
          >
            Kirim Pesan
          </button>
        </div>

        <div *ngIf="buttonLoading" class="submit-complaint">
          <button class="btn btn-block complaint " disabled>
            <span class="spinner-border spinner-border-sm"></span>
            Loading..
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
